import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { createFlatBufferBaseQuery } from "../../flatbuffers/api/flatBufferBaseQuery";

const maxRetries = 2;

const baseQuery = retry(
  createFlatBufferBaseQuery(process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE ?? ""),
  { maxRetries },
);

export const loginAPI = createApi({
  reducerPath: "loginAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: [],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET ME OFFLINE PASSWORD */
    getMeOfflinePSW: builder.query({
      query: (body: any) => ({
        url: `/users/offline-psw`,
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* POST ME OFFLINE PASSWORD */
    postMeOfflinePSW: builder.mutation({
      query: (body: any) => ({
        url: `/users/offline-psw`,
        method: "POST",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* POST USER OFFLINE PASSWORD */
    postUserPsw: builder.mutation({
      query: (body: any) => ({
        url: `/users/offline-psw/${body.body.user_id}`,
        method: "POST",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET USER OFFLINE PASSWORD */
    getUserPsw: builder.query({
      query: (body: any) => ({
        url: `/users/offline-psw/${body.body.user_id}`,
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* POST LOGIN OFFLINE */
    postLoginOffline: builder.mutation({
      query: (body: any) => ({
        url: `/offline/login`,
        method: "POST",
        body: body.body,
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* POST OFFLINE INITIAL PASSWORD (first-login set-password) */
    postOfflineInitialPassword: builder.mutation({
      query: (body: any) => ({
        url: `/offline/initial-password`,
        method: "POST",
        body: body.body,
      }),
    }),
    //* *********************************************************** */
    //* POST OWN CUSTOM OFFLINE PASSWORD (forced change at first sign-in) */
    //
    //* Distinct from postOfflineInitialPassword above: that one is
    //* UNAUTHENTICATED and only serves accounts with no password at all. A user
    //* created on an edge server already HAS a password -- the one the server
    //* generated -- so they authenticate with it first and then replace it
    //* here, carrying the token the login issued.
    postOwnCustomOfflinePassword: builder.mutation({
      query: (body: any) => ({
        url: `/users/new-offline-psw`,
        method: "POST",
        body: body.body,
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
  }),
});

export const {
  useLazyGetMeOfflinePSWQuery,
  usePostMeOfflinePSWMutation,
  useLazyGetUserPswQuery,
  usePostUserPswMutation,
  usePostLoginOfflineMutation,
  usePostOfflineInitialPasswordMutation,
  usePostOwnCustomOfflinePasswordMutation,
} = loginAPI;
